import { useNavigate } from 'react-router-dom'
import { AlertStatusModal } from '@/shared/components/confirmation'
import { INSTRUMENT_UNAVAILABLE } from '../lib/instrument-info-messages'

interface InstrumentPausedDialogProps {
  readonly open: boolean
  readonly message?: string
}

/** Paused instrument — modal with Back to home (matches response MS `instrument_paused`). */
export function InstrumentPausedDialog({
  open,
  message = INSTRUMENT_UNAVAILABLE,
}: InstrumentPausedDialogProps) {
  const navigate = useNavigate()
  const goHome = () => navigate('/', { replace: true })

  return (
    <AlertStatusModal
      open={open}
      headline="Survey unavailable"
      bodyLines={[message]}
      primaryLabel="Back to home"
      onPrimary={goHome}
      onClose={goHome}
      dialogTestId="instrument-paused-dialog"
      primaryTestId="instrument-paused-dialog-back-home"
    />
  )
}
